import React from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import Select from 'orionsoft-parts/lib/components/fields/Select'
import SmallSelect from 'App/components/fields/SmallSelect'

export default function CountryCode(props) {
  const {small} = props
  const {countries, loading} = useQuery({
    query: gql`
      query {
        countries {
          value: code
          label: name
        }
      }
    `,
    partial: true
  })

  const options = countries || []

  if (small) return <SmallSelect {...props} options={options} noValueLabel="Selecciona un país" />

  return <Select placeholder="Selecciona un país" {...props} options={options} loading={loading} />
}
